module.exports = require("@apollo/client/core");